module.exports = __webpack_public_path__ + "static/media/A.c07b7a92.jpg";